export const TRIGGER_DISPLAY_TOAST = 'TOAST.TRIGGER_DISPLAY_TOAST';
export const ADD_TOAST = 'TOAST.ADD_TOAST';
export const REMOVE_TOAST = 'TOAST.REMOVE_TOAST';

export type ToastType = "WARNING" | "SUCCESS" | "ERROR";

export interface Toast {
  id: string;
  title: string;
  message: string;
  type: ToastType;
}

export interface TriggerDisplayToastPayload {
  title?: string;
  message?: string;
  toastType: ToastType;
  durationMs?: number;
}

export interface TriggerDisplayToast {
  type: typeof TRIGGER_DISPLAY_TOAST;
  payload: TriggerDisplayToastPayload;
}

export interface AddToast {
  type: typeof ADD_TOAST;
  payload: {
    toast: Toast;
  }
}

export interface RemoveToast {
  type: typeof REMOVE_TOAST;
  payload: {
    toastId: string;
  };
}


export type ToastActionType =
  TriggerDisplayToast
  | AddToast
  | RemoveToast;


export interface ToastState {
  toasts: Toast[];
}